import {useMutation, useQueryClient} from '@tanstack/react-query'
import {MUTATION_KEYS} from './keys'
import {verify18AgeWithGoCam} from '../services/feed.http'
import {QUERY_KEYS as AUTHENTICATION_QUERY_KEYS} from '@/features/authentication/queries/keys'

export const useVerify18AgeWithGoCam = (onSuccess?: (redirectUrl: string) => void) => {
    const queryClient = useQueryClient()
    return useMutation({
        mutationKey: [MUTATION_KEYS.verify_18_age_with_gocam],
        mutationFn: verify18AgeWithGoCam,
        onSuccess: (data: {url: string}) => {
            queryClient.invalidateQueries({queryKey: [AUTHENTICATION_QUERY_KEYS.user]})
            if (!!data.url) {
                onSuccess?.(data.url)
            }
        }
    })
}
